export const OPEN_REPORTS_NAVIGATION_EVENT = 'open-reports-navigation'

export const isReportsNavigationUrl = (url) => {
  if (typeof url !== 'string') return false

  const pathname = url.split(/[?#]/)[0].replace(/\/+$/, '')

  return pathname === '/reports' || pathname.startsWith('/reports/')
}

export const openReportsNavigation = () => {
  window.dispatchEvent(new Event(OPEN_REPORTS_NAVIGATION_EVENT))
}
